export const ROUTE_MAP_OPTIONS = Object.freeze({
  disableDefaultUI: true,
  zoomControl: false,
  gestureHandling: "greedy",
  draggable: true,
  scrollwheel: true,
  keyboardShortcuts: true,
  clickableIcons: true,
});
